import { styles } from '@app/services/app-styles.service';

const autocomplete = {
    root: {
        paddingX: styles().paddingXs,
        paddingY: styles().paddingXs,
    },
    chip: {
        borderRadius: styles().borderRadiusInput,
    },
};

export default autocomplete;
